import Flickity from "flickity-imagesloaded";

export default class ModuleShowcase {
  constructor(dom) {
    this.dom = dom;
    this.tickerSpeed = 2;
    this.isPaused = false;
  }

  init() {
    this.initSlider();
  }

  initSlider() {
    this.sliderDOM = this.dom.querySelector("[js-carousel]");
    this.sliderDOM.style.opacity = 0;

    this.slider = new Flickity(this.sliderDOM, {
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      draggable: true,
      wrapAround: true,
      selectedAttraction: 0.015,
      friction: 0.25,
      imagesLoaded: true,
      on: {
        ready: () => {
          setTimeout(() => {
            this.sliderDOM.style.opacity = 1;
          }, 500);
        },
      },
    });
    this.slider.x = 0;

    this.sliderDOM.addEventListener(
      "mouseenter",
      () => {
        this.pause();
      },
      false
    );
    this.sliderDOM.addEventListener(
      "focusin",
      () => {
        this.pause();
      },
      false
    );
    this.sliderDOM.addEventListener(
      "mouseleave",
      () => {
        this.play();
      },
      false
    );
    this.sliderDOM.addEventListener(
      "focusout",
      () => {
        this.play();
      },
      false
    );

    this.slider.on("dragStart", () => {
      this.isPaused = true;
    });

    this.update();
  }

  update() {
    if (this.isPaused) return;
    if (this.slider.slides) {
      this.slider.x =
        (this.slider.x - this.tickerSpeed) % this.slider.slideableWidth;
      this.slider.selectedIndex = this.slider.dragEndRestingSelect();
      this.slider.updateSelectedSlide();
      this.slider.settle(this.slider.x);
    }
    window.requestAnimationFrame(() => {
      this.update();
    });
  }

  pause() {
    this.isPaused = true;
  }

  play() {
    if (this.isPaused) {
      this.isPaused = false;
      window.requestAnimationFrame(() => {
        this.update();
      });
    }
  }
}
